import React from "react";
import { object, string, number, array } from "prop-types";

import Carousel from "../../atoms/carousel";
import Headline from "../../atoms/headline";
import CardImageType5 from "../card-image-type-5";
import CardImageType6 from "../card-image-type-6";

import "./carousel-slider.m.css";
import Organism5 from "../../organisms/organism-5";
import Arrow1 from "./arrow-1";
import Arrow2 from "./arrow-2";

const CarouselSlider = ({ collection, type = "default", headlineLimit, widths = [250, 480, 764] }) => {
  const storiesFromCollection = collection.items.filter(item => item.type === "story");
  const children = storiesFromCollection.map((story, key) => (
    <div key={key}>
      {type === "videos"
        ? story && <CardImageType6 story={story.story} headlineLimit={headlineLimit} widths={widths} />
        : story && <CardImageType5 story={story} headlineLimit={70} widths={widths} />}
    </div>
  ));

  const filteredCollection = collection.items.filter(item => item.type === "collection");
  const collectionChildren = filteredCollection.filter(item => item.items.length > 0).map((collectionItem, key) => {
    return (
      <div key={key}>
        <Organism5 collection={collectionItem} widths={widths} />
      </div>
    );
  });

  const getTotalItems = () => {
    return type === "collection" ? filteredCollection.length : storiesFromCollection.length;
  };

  return (
    <div styleName="carousel-container">
      <div styleName="headline-container">
        <Headline headline={collection.name} headerLevel={2} />
      </div>

      <Carousel
        carouselName={`carousel-${collection.slug}`}
        options={{
          type: "carousel",
          perView: 4,
          gap: 24,
          breakpoints: { 480: { perView: 1, peek: { before: 0, after: 80 } } }
        }}
        totalItems={getTotalItems()}
        renderCenterLeftControls={({ previousSlide, currentSlide }) => {
          return (
            currentSlide !== 0 && (
              <button onClick={previousSlide} className="slider-btn">
                <Arrow2 />
              </button>
            )
          );
        }}
        renderCenterRightControls={({ nextSlide }) => (
          <button onClick={nextSlide} className="slider-btn">
            <Arrow1 />
          </button>
        )}
      >
        {type === "collection" ? collectionChildren : children}
      </Carousel>
    </div>
  );
};

export default CarouselSlider;

CarouselSlider.propTypes = {
  collection: object,
  type: string,
  headlineLimit: number,
  widths: array
};
